module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "out_container"
  }, [_c('div', {
    staticClass: "header min_wrapper_1200"
  }, [_c('div', {
    staticClass: "headerCon wrapper_1200 acea-row row-between-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);",
      "rel": "sidebar"
    },
    on: {
      "click": function($event) {
        return _vm.AddFavorite()
      }
    }
  }, [_c('span', {
    staticClass: "iconfont icon-shoucang2"
  }), _vm._v("收藏本站")]), _vm._v(" "), _c('div', {
    staticClass: "user acea-row row-middle"
  }, [(_vm.user.name) ? _c('span', {
    staticClass: "item acea-row row-middle",
    staticStyle: {
      "margin-right": "25px"
    }
  }, [_c('p', {
    staticClass: "line1",
    staticStyle: {
      "max-width": "135px"
    }
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("[退出]")])]) : _vm._e(), _vm._v(" "), (!_vm.user.name) ? _c('span', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'login'
      }),
      expression: "{name:'login'}"
    }],
    staticClass: "item"
  }, [_vm._v("登录/注册")]) : _vm._e(), _vm._v(" "), (_vm.user.name) ? _c('span', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'orderList'
      }),
      expression: "{name:'orderList'}"
    }],
    staticClass: "item"
  }, [_vm._v("我的订单")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'cart'
      }),
      expression: "{name:'cart'}"
    }],
    staticClass: "cartNum",
    class: 'on'
  }, [_c('span', {
    staticClass: "iconfont icon-dingbu-gouwuche"
  }), _vm._v("购物车")]), _vm._v(" "), _vm._t("right")], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "nav min_wrapper_1200",
    attrs: {
      "data-v-a525b892": ""
    }
  }, [_c('div', {
    staticClass: "navCon wrapper_1200 acea-row row-between-wrapper",
    attrs: {
      "data-v-a525b892": ""
    }
  }, [_c('div', {
    staticClass: "textPic acea-row row-middle",
    attrs: {
      "data-v-a525b892": ""
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "list",
    attrs: {
      "data-v-a525b892": ""
    }
  }, [_c('a', {
    staticClass: "item",
    class: _vm.$route.path == '/indexpc' ? 'nuxt-link-exact-active nuxt-link-active font-color' : '',
    attrs: {
      "data-v-a525b892": "",
      "href": "/",
      "aria-current": "page"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: _vm.$route.path == '/goodslist' ? 'nuxt-link-exact-active nuxt-link-active font-color' : '',
    attrs: {
      "data-v-a525b892": "",
      "href": "./goodslist"
    }
  }, [_vm._v("采购商城")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: _vm.$route.path == '/aboutus' ? 'nuxt-link-exact-active nuxt-link-active font-color' : '',
    attrs: {
      "data-v-a525b892": "",
      "href": "./aboutus"
    }
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: _vm.$route.path == '/BusinessForm' ? 'nuxt-link-exact-active nuxt-link-active font-color' : '',
    attrs: {
      "data-v-a525b892": "",
      "href": "./BusinessForm"
    }
  }, [_vm._v("供应商入驻")])])]), _vm._v(" "), _c('div', {
    staticClass: "search acea-row row-between-wrapper",
    attrs: {
      "data-v-a525b892": ""
    }
  }, [_c('div', {
    staticClass: "text acea-row row-middle",
    attrs: {
      "data-v-a525b892": ""
    }
  }, [_c('span', {
    staticClass: "iconfont icon-xiazai5",
    attrs: {
      "data-v-a525b892": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    attrs: {
      "data-v-a525b892": "",
      "type": "text",
      "placeholder": "搜索商品"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bnt bg-color",
    attrs: {
      "data-v-a525b892": ""
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("搜索")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "loginhead"
  }, [_c('div', {
    staticClass: "headleft"
  }, [_c('div', {
    staticClass: "logoAndname",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'IndexPc'
        })
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/login/jiafu-logo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "headnav"
  }, _vm._l((_vm.navArr), function(item, index) {
    return _c('a', {
      key: index + 'a',
      class: item.class,
      on: {
        "click": function($event) {
          return _vm.handleNavClick(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), (_vm.user.id > 0) ? _c('div', {
    staticClass: "headlefticon"
  }, [_c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'UpdataInfo'
      }),
      expression: "{ name: 'UpdataInfo' }"
    }],
    staticClass: "headlefticon_name",
    staticStyle: {
      "color": "#fff",
      "display": "flex",
      "flex-direction": "row",
      "align-items": "center",
      "margin-left": "10px",
      "font-size": "16px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.user.name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "headicon"
  }, [_c('div', {
    staticClass: "loginbtn registerbtn",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])])]) : _c('div', {
    staticClass: "headlefticon"
  }, [_c('div', {
    staticClass: "headicon"
  }, [_c('div', {
    staticClass: "loginbtn",
    on: {
      "click": function($event) {
        return _vm.loginOrRegisterClickFun(1)
      }
    }
  }, [_vm._v("登录11")])]), _vm._v(" "), _c('div', {
    staticClass: "headicon"
  }, [_c('div', {
    staticClass: "loginbtn registerbtn",
    on: {
      "click": function($event) {
        return _vm.loginOrRegisterClickFun(2)
      }
    }
  }, [_vm._v("\n              注册\n            ")])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "wrapper_1200"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "recordNum"
  }, [_c('div', [_c('span', [_vm._v("联系电话：18936019528")]), _c('span', {
    staticClass: "address"
  }, [_vm._v("地址：江苏省南京市江北新区星火路1号")]), _vm._v(" "), _vm._t("right")], 2), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "floatWindow"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.chatShow
    }
  }, [_c('div', {
    staticClass: "iconfont icon-lianxikefu"
  }), _vm._v(" "), _c('div', [_vm._v("联系客服")])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "mouseleave": _vm.wxCodeHide
    }
  }, [_c('div', {
    on: {
      "mouseenter": _vm.wxCode
    }
  }, [_c('div', {
    staticClass: "iconfont icon-weixin4"
  }), _vm._v(" "), _c('div', [_vm._v("关注微信")])]), _vm._v(" "), (_vm.iScode) ? _c('div', {
    staticClass: "itemCon"
  }, [_c('div', {
    staticClass: "ewm"
  }, [_c('div', {
    staticClass: "pictrue"
  }, [_c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('img', {
    staticClass: "bicode",
    attrs: {
      "src": _vm.codeUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("扫码关注公众号")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.goCart
    }
  }, [_c('div', {
    staticClass: "iconfont icon-cedaohang-gouwuche"
  }), _vm._v(" "), _c('div', [_vm._v("购物车")])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.goTop
    }
  }, [_c('div', {
    staticClass: "iconfont icon-huidaodingbu1"
  }), _vm._v(" "), _c('div', [_vm._v("回到顶部")])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon",
    attrs: {
      "data-v-a525b892": ""
    }
  }, [_c('img', {
    attrs: {
      "data-v-a525b892": "",
      "src": require("@/assets/images/login/jiafu-logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "acea-row row-around row-middle"
  }, [_c('li', {
    staticClass: "acea-row row-middle"
  }, [_c('div', {
    staticClass: "picture"
  }, [_c('span', {
    staticClass: "iconfont icon-pinzhong"
  })]), _vm._v(" "), _c('div', [_vm._v("品种齐全，购物轻松")])]), _vm._v(" "), _c('li', {
    staticClass: "acea-row row-middle"
  }, [_c('div', {
    staticClass: "picture"
  }, [_c('span', {
    staticClass: "iconfont icon-zhifa"
  })]), _vm._v(" "), _c('div', [_vm._v("多仓直发，极速配送")])]), _vm._v(" "), _c('li', {
    staticClass: "acea-row row-middle"
  }, [_c('div', {
    staticClass: "picture"
  }, [_c('span', {
    staticClass: "iconfont icon-hanghuo"
  })]), _vm._v(" "), _c('div', [_vm._v("正品行货，精致服务")])]), _vm._v(" "), _c('li', {
    staticClass: "acea-row row-middle"
  }, [_c('div', {
    staticClass: "picture"
  }, [_c('span', {
    staticClass: "iconfont icon-dijia"
  })]), _vm._v(" "), _c('div', [_vm._v("天天低价，畅选无忧")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "record"
  }, [_vm._v("\n            版权所有"), _c('a', {
    staticClass: "num",
    attrs: {
      "href": "http://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("\n            苏ICP备05082904号-2")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d65f7de0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/IndexLayout.vue
// module id = 1329
// module chunks = 0